import type { GenericTranslationsObject } from '@payloadcms/translations'

export const fa: GenericTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-seo': {
    almostThere: 'چیزیی باقی نمونده',
    autoGenerate: 'تولید خودکار',
    bestPractices: 'آموزش بیشتر',
    characterCount: '{{current}}/{{minLength}}-{{maxLength}} کلمه، ',
    charactersLeftOver: '{{characters}} باقی مانده',
    charactersToGo: '{{characters}} باقی مانده',
    charactersTooMany: '{{characters}} بیش از حد',
    checksPassing: '{{current}}/{{max}} بررسی‌ها با موفقیت انجام شده است',
    good: 'خوب',
    imageAutoGenerationTip:
      'این قابلیت، تصویر فعلی بارگذاری شده در مجموعه محتوای شما را بازیابی می‌کند',
    lengthTipDescription:
      'این باید بین {{minLength}} و {{maxLength}} کلمه باشد. برای کمک در نوشتن توضیحات متا با کیفیت، مراجعه کنید به ',
    lengthTipTitle:
      'این باید بین {{minLength}} و {{maxLength}} کلمه باشد. برای کمک در نوشتن عناوین متا با کیفیت، مراجعه کنید به ',
    missing: 'ناقص',
    noImage: 'بدون تصویر',
    preview: 'پیش‌نمایش',
    previewDescription: 'فهرست نتایج ممکن است بر اساس محتوا و متناسب با کلمه کلیدی جستجو شده باشند',
    tooLong: 'خیلی طولانی',
    tooShort: 'خیلی کوتاه',
  },
}
